import { ClientPurchaseOrderFolder } from "@redotech/redo-model/views/folders";
import { ClientPurchaseOrdersView } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const updatePurchaseOrderViewOrdering = {
  name: "updatePurchaseOrderViewOrdering" as const,
  input: z.object({
    views: z.array(ClientPurchaseOrdersView),
    folders: z.array(ClientPurchaseOrderFolder),
  }),
  output: z.object({}),
};
